import React, { useEffect, useState } from 'react';
import './NewGstinPage.css';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
// import Select from 'react-select';
import axios from 'axios';
import ClipLoader from "react-spinners/ClipLoader";
import CancelIcon from '@mui/icons-material/Cancel';


const NewGstinPage = ({ clientGSTIN }) => {
  console.log(clientGSTIN, "clientGSTIN")
  const [gstin, setGstin] = useState(clientGSTIN || "");

  const [isFound, setIsFound] = useState({
    gstinFound: null,
    panFound: null
  });
  const [gstinData, setGstinData] = useState({
    tradeName: '',
    legalName: '',
    status: false,
  });
  const [additionalDetails, setAdditionalDet] = useState({
    entity_name: '',
    pan: ''
  })
  const [messages, setMessages] = useState({
    gstMsg: '',
    panMsg: '',
    workspaceMsg: '',
    allGstinMsg: '',
  });
  const [loading, setLoading] = useState(false); // Loader state
  const [tableData, setTableData] = useState([]);
  const [workspaceName, setWorkspaceName] = useState(''); // Initially empty workspace name

  const fetchWorkspaceName = async () => {
    try {
      const panNumber = gstin.substring(2, gstin.length - 3); // Extract PAN from GSTIN

      const response = await fetch(`https://stage-apiplatform.finkraft.ai/api/meta/get-workspace-name?gstin=${gstin}&pan_number=${panNumber}`);
      const data = await response.json();

      if (data && data.workspaceName) {
        setWorkspaceName(data.workspaceName);
      } else {
        setWorkspaceName('Not Found');
      }
    } catch (error) {
      console.error('Error fetching workspace name:', error);
      setWorkspaceName('Error');
    }
  };

  // Ag-Grid column definitions
  const columnDefs = [
    { headerName: "GSTIN", field: "gstin", sortable: true, filter: true, flex: 1, enableRowGroup: true, },
    { headerName: "Legal Name", field: "legalname", sortable: true, filter: true, flex: 1, enableRowGroup: true, },
    { headerName: "Trade Name", field: "tradename", sortable: true, filter: true, flex: 1, enableRowGroup: true, },
    { headerName: "Status", field: "status", sortable: true, filter: true, flex: 1, enableRowGroup: true, },
    { headerName: "Found in DB", field: "foundindb", sortable: true, filter: true, flex: 1, enableRowGroup: true, },
  ];

  const searchGstin = async () => {
    try {
      setLoading(true)
      // Reset messages at the start
      setGstMessage("");  // Reset gstMessage to an empty string
      setMessages({
        gstMsg: '',
        panMsg: '',
        workspaceMsg: '',
        allGstinMsg: '',
      });
      setGstStatusMsg("")
      // Extract PAN number from GSTIN by removing the first 2 and last 3 characters
      const panNumber = gstin.substring(2, gstin.length - 3);

      // Call the search APIs
      const gstinSearchApi = fetch(`https://stage-apiplatform.finkraft.ai/api/meta/search-gstin?gstin=${gstin}`);
      const gstinDetailsApi = fetch(`https://stage-apiplatform.finkraft.ai/api/meta/get-gstin-details?gstin=${gstin}`);

      // Sending pan_number in the body for the /api/search-gstins API
      const gstinSearchAllApi = fetch('https://stage-apiplatform.finkraft.ai/api/meta/search-gstins', {
        method: 'POST',  // Using POST method
        headers: {
          'Content-Type': 'application/json',  // Set the content type to JSON
        },
        body: JSON.stringify({
          pan_number: panNumber,  // Send the pan_number extracted from the gstin
        }),
      });

      const getentityname = fetch('https://stage-apiplatform.finkraft.ai/api/meta/getentityname', {
        method: 'POST',  // Using POST method
        headers: {
          'Content-Type': 'application/json',  // Set the content type to JSON
        },
        body: JSON.stringify({
          pan_number: panNumber,  // Send the pan_number extracted from the gstin
        }),
      });

      const [searchResponse, detailsResponse, searchAllResponse, AdditionalDetailsResp] = await Promise.all([gstinSearchApi, gstinDetailsApi, gstinSearchAllApi, getentityname]);

      const searchData = await searchResponse.json();
      const detailsData = await detailsResponse.json();
      const searchAllData = await searchAllResponse.json();
      const AdditionalDetails = await AdditionalDetailsResp.json()

      setIsFound({
        gstinFound: searchData.gstinFound,
        panFound: searchData.panFound
      });

      setAdditionalDet({
        entity_name: AdditionalDetails.entity_name,
        pan: AdditionalDetails.pan_number
      })

      // Check if the status is 'active' to update the checkbox state
      setGstinData({
        tradeName: detailsData.tradeName,
        legalName: detailsData.legalName,
        status: detailsData.status, // This will make the checkbox checked if status is 'active'
      });

      // Handle the results from the '/api/search-gstins' API (show in ag-Grid)
      setGstinSearchResults(searchAllData); // Assuming setGstinSearchResults is implemented to store search results for ag-Grid

      fetchWorkspaceName(); // Fetch workspace after GSTIN details
      setLoading(false)
    } catch (error) {
      console.error('Error fetching GSTIN details:', error);
      setIsFound(false);
      setGstinData({ tradeName: '', legalName: '', status: false });
    }
  };

  const [gstinSearchResults, setGstinSearchResults] = useState([]);




  const [workspaces, setWorkspaces] = useState([]); // Store the list of all workspaces
  const [filteredWorkspaces, setFilteredWorkspaces] = useState([]); // Store filtered workspaces for suggestions
  const [isDropdownVisible, setIsDropdownVisible] = useState(false); // Control visibility of dropdown
  const [query, setQuery] = useState(''); // Store user input for search

  // Fetch workspaces from the API when the component mounts
  useEffect(() => {
    const fetchWorkspaces = async () => {
      try {
        const response = await fetch('https://apiplatform.finkraft.ai/meta/workspaces');
        const data = await response.json();
        setWorkspaces(data);
        setFilteredWorkspaces(data); // Initially show all workspaces
      } catch (error) {
        console.error('Error fetching workspaces:', error);
      }
    };
    fetchWorkspaces();
  }, []);

  const handleInputChange = (event) => {
    const input = event.target.value || ''; // Ensure input is a string
    setQuery(input);

    if (input.length >= 1) {
      // Filter workspaces based on the input and show the dropdown
      const suggestions = workspaces.filter(workspace =>
        (workspace.name && workspace.name.toLowerCase().includes(input.toLowerCase())) // Check if workspace.name exists
      ).slice(0, 5); // Limit to 4-5 suggestions
      setFilteredWorkspaces(suggestions);
      setIsDropdownVisible(true);
    } else {
      setIsDropdownVisible(false);
    }
  };


  const handleWorkspaceSelect = (workspace) => {
    setWorkspaceName(workspace.name); // Set the workspace name
    setQuery(workspace.name); // Populate the input with selected workspace name
    setIsDropdownVisible(false); // Hide the dropdown after selection
  };



  const handleClearClick = () => {
    setWorkspaceName(''); // Clear the workspace name
    setQuery(''); // Clear the search query
    setIsDropdownVisible(false); // Hide dropdown
  };


  const [gstMessage, setGstMessage] = useState("");
  const [gstStatusMsg, setGstStatusMsg] = useState("");

  const saveGstin = async () => {
    try {
      // Validate if GSTIN and workspace name are provided
      if (!gstin || !workspaceName) {
        alert('Please enter GSTIN and select a workspace.');
        return;
      }

      // First API call to save the GSTIN
      const response = await fetch('https://stage-apiplatform.finkraft.ai/api/meta/gstin/add', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          gstin,
          workspace: workspaceName,
        }),
      });

      const data = await response.json(); // Parsing response body

      if (response.ok) {
        alert('GSTIN saved successfully!');
        setMessages({
          gstMsg: data.messages["gst-msg"] || '',
          panMsg: data.messages["pan-msg"] || '',
          workspaceMsg: data.messages["workspace-msg"] || '',
          allGstinMsg: data.messages["all-gstn-msg"] || '',  // Fixing the key name
        });

        // Only call the second API if the first one is successful
        const gstinData = gstinSearchResults.map(row => ({
          gstin: row.gstin,
          legalname: row.legalname,
          tradename: row.tradename,
          status: row.status
        }));

        console.log(gstinData)

        const secondApiResponse = await fetch('https://stage-apiplatform.finkraft.ai/api/meta/gstin/save', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(gstinData),
        });

        const secondApiData = await secondApiResponse.json();

        if (secondApiResponse.ok) {
          // Update the message state with the response from the second API
          setGstMessage(secondApiData.message || 'Data saved successfully!');
        } else {
          setGstMessage(`Error in saving data: ${secondApiData.message || 'Unknown error'}`);
        }
      } else {
        alert(`Error saving GSTIN: ${data.message || 'Unknown error'}`);
      }
    } catch (error) {
      console.error('Error saving GSTIN:', error);
      alert('An error occurred while saving the GSTIN. Please try again.');
    }
  };



  const handleStatusChange = async () => {
    const updatedStatus = gstinData.status === null ? true : !gstinData.status;

    setGstinData((prev) => ({ ...prev, status: updatedStatus })); // Update local state optimistically

    try {
      const response = await axios.post(
        "https://stage-apiplatform.finkraft.ai/api/meta/update_gstin_status",
        {
          gstin: gstin,
          status: updatedStatus,
        }
      );
      console.log("Status updated successfully:", response.data);
      setGstStatusMsg(`Status updated successfully to: ${updatedStatus}`)
      alert(`Status updated successfully to: ${updatedStatus}`);
    } catch (error) {
      console.error("Error updating status:", error);
      // Revert the status change in case of an error
      setGstinData((prev) => ({ ...prev, status: !updatedStatus }));
    }
  };


  return (
    <div className="newgstinpage-container">
      {loading && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 10,
            padding: '400px',
          }}
        >
          <ClipLoader color="#36D7B7" size={50} />
        </div>
      )}

      <div className="newgstinpage-header">
        <label htmlFor="gstin-search" className="newgstinpage-label">GSTIN:</label>
        <input
          type="text"
          id="gstin-search"
          className="newgstinpage-input"
          placeholder="Enter GSTIN"
          //   value={gstin}
          value={clientGSTIN}
        // onChange={() => setGstin(clientGSTIN)} 
        //   onChange={(e) => setGstin(e.target.value)}

        />
        <button className="newgstinpage-btn" onClick={searchGstin}>Search</button>
        <button className="newgstinpage-savebtn" onClick={saveGstin}>Save GSTIN</button>
      </div>

      <div className="newgstinpage-cards">
        <div className="newgstinpage-card">
          <div className="newgstinpage-field">
            <label>Gstin Found in Database:</label>
            {isFound.gstinFound !== null && (
              <span className={`newgstinpage-status ${isFound.gstinFound ? 'newgstinpage-success' : 'newgstinpage-fail'}`}>
                {isFound.gstinFound ? '✅' : '❌'}
              </span>
            )}
          </div>
          <div className="newgstinpage-field">
            <label>Legal Name:</label>
            <span>{gstinData.legalName || 'N/A'}</span>
          </div>
          <div className="newgstinpage-field">
            <label>Trade Name:</label>
            <span>{gstinData.tradeName || 'N/A'}</span>
          </div>
          <div className="newgstinpage-field">
            <label>is_active(DA):</label>
            <input type="checkbox" className="newgstinpage-checkbox" checked={gstinData.status} onChange={handleStatusChange} />
          </div>
          {messages.gstMsg && <p style={{ color: 'green' }}>{messages.gstMsg}</p>} {/* Display gstMsg */}
          {gstStatusMsg && <p style={{ color: 'green' }}>{gstStatusMsg}</p>}
        </div>

        <div className="newgstinpage-card">
          <div className="newgstinpage-field">
            <label>Pan Found in Database:</label>
            {isFound.panFound !== null && (
              <span className={`newgstinpage-status ${isFound.panFound ? 'newgstinpage-success' : 'newgstinpage-fail'}`}>
                {isFound.panFound ? '✅' : '❌'}
              </span>
            )}
          </div>
          <div className="newgstinpage-field">
            <label>PAN:</label>
            <span>{additionalDetails.pan}</span>
          </div>
          <div className="newgstinpage-field">
            <label>Entity Name:</label>
            <span>{additionalDetails.entity_name}</span>
          </div>
          {messages.panMsg && <p style={{ color: 'green' }}>{messages.panMsg}</p>} {/* Display panMsg */}
        </div>
      </div>

      <div className="newgstinpage-aggrid">
        <div className="ag-theme-alpine" style={{ height: 300, width: '100%' }}>
          <AgGridReact
            columnDefs={columnDefs}
            rowData={gstinSearchResults}
            rowGroupPanelShow="always"
          />
        </div>
        {messages.allGstinMsg && <p style={{ color: 'green' }}>{messages.allGstinMsg}</p>} {/* Display allGstinMsg */}
        {gstMessage && <p style={{ color: 'green' }}>{gstMessage}</p>}
      </div>

      <div className="newgstinpage-workspace">
        <div className="workspace-card">
          <label className="workspace-label">Workspace Name:</label>
          <div className="search-container">
            <input
              type="text"
              className="search-input"
              placeholder="Search Workspace Name"
              value={query || workspaceName || ''}
              onChange={handleInputChange}
            />
            {(query || workspaceName) && (
              <span className="clear-icon" onClick={handleClearClick}>
                <CancelIcon />
              </span>
            )}
          </div>
          {messages.workspaceMsg && <p style={{ color: 'green' }}>{messages.workspaceMsg}</p>}

          {isDropdownVisible && query.length >= 2 && (
            <div className="dropdown-workspace">
              {filteredWorkspaces.length > 0 ? (
                filteredWorkspaces.map((workspace) => (
                  <div
                    key={workspace.id}
                    className="dropdown-item"
                    onClick={() => handleWorkspaceSelect(workspace)}
                  >
                    {workspace.name}
                  </div>
                ))
              ) : (
                <div
                  className="dropdown-item add-new-workspace"
                  onClick={() => handleWorkspaceSelect({ name: query })}
                >
                  + Create New Workspace "{query}"
                </div>
              )}
            </div>
          )}
        </div>

      </div>
    </div>
  );
};

export default NewGstinPage;